export const SRI_LANKA_TIMEZONE = 'Asia/Colombo';
const UI_DATE_LOCALE = 'en-GB';
const SRI_LANKA_DATE_FORMATTER = new Intl.DateTimeFormat(UI_DATE_LOCALE, {
  timeZone: SRI_LANKA_TIMEZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});
const SRI_LANKA_DATE_TIME_FORMATTER = new Intl.DateTimeFormat(UI_DATE_LOCALE, {
  timeZone: SRI_LANKA_TIMEZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});
const SRI_LANKA_OFFSET = '+05:30';

function formatParts(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: SRI_LANKA_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);

  let year = '';
  let month = '';
  let day = '';
  for (const part of parts) {
    if (part.type === 'year') year = part.value;
    if (part.type === 'month') month = part.value;
    if (part.type === 'day') day = part.value;
  }
  return { year, month, day };
}

function parseDateLike(value) {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const text = String(value || '').trim();
  if (!text) return null;

  const ymdMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/);
  if (ymdMatch) {
    const [, year, month, day] = ymdMatch;
    return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), 12, 0, 0));
  }

  const monthMatch = text.match(/^(\d{4})-(\d{2})$/);
  if (monthMatch) {
    const [, year, month] = monthMatch;
    return new Date(Date.UTC(Number(year), Number(month) - 1, 1, 12, 0, 0));
  }

  const sriLankaDateTimeMatch = text.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/
  );
  if (sriLankaDateTimeMatch) {
    const [, year, month, day, hour, minute, second = '00'] = sriLankaDateTimeMatch;
    return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}${SRI_LANKA_OFFSET}`);
  }

  const normalized = text.includes(' ') && !text.includes('T')
    ? text.replace(' ', 'T')
    : text;
  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getSriLankaTodayYmd(date = new Date()) {
  const parts = formatParts(date);
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function getSriLankaMonthValue(date = new Date()) {
  return getSriLankaTodayYmd(date).slice(0, 7);
}

export function getSriLankaCurrentYear(date = new Date()) {
  return Number(formatParts(date).year || 0);
}

export function getSriLankaCurrentMonth(date = new Date()) {
  return Number(formatParts(date).month || 0);
}

export function formatSriLankaDateLabel(value) {
  const parsed = parseDateLike(value);
  if (!parsed) return String(value || '');
  return SRI_LANKA_DATE_FORMATTER.format(parsed);
}

export function formatSriLankaMonthLabel(value) {
  const text = String(value || '').trim();
  const monthMatch = text.match(/^(\d{4})-(\d{2})$/);
  if (monthMatch) {
    return `${monthMatch[2]}/${monthMatch[1]}`;
  }

  const parsed = parseDateLike(value);
  if (!parsed) return String(value || '');
  const parts = formatParts(parsed);
  return `${parts.month}/${parts.year}`;
}

export function formatSriLankaDateTimeLabel(value) {
  const parsed = parseDateLike(value);
  if (!parsed) return String(value || '');
  return SRI_LANKA_DATE_TIME_FORMATTER.format(parsed);
}
